export default __webpack_public_path__ + "static/media/perf-rocks.0eeb7f4b.svg";